module.exports = __webpack_public_path__ + "img/virus.3226a0f7.webp";